import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiFetch } from "../../hooks/useAuth";

export const AdminShell = ({ user, children }) => {
  const nav = useNavigate();
  const signOut = async () => {
    await apiFetch("/api/admin/logout", { method: "POST" });
    nav("/admin/login");
  };
  return (
    <div className="min-h-screen bg-offwhite text-navy flex flex-col">
      <header className="border-b border-navy/8">
        <div className="mx-auto max-w-[1100px] px-6 sm:px-8 lg:px-10 flex items-center justify-between h-16">
          <Link to="/admin/submissions" className="inline-flex items-center gap-2.5" data-testid="admin-wordmark">
            <span className="font-serif text-[22px] leading-none text-navy">QUANTUM</span>
            <span aria-hidden="true" className="inline-block bg-gold" style={{ width: 4, height: 4 }} />
            <span
              className="hidden sm:inline font-sans uppercase text-navy/70"
              style={{ fontSize: "10.5px", letterSpacing: "0.22em" }}
            >
              Office Console
            </span>
          </Link>
          {user ? (
            <div className="flex items-center gap-6">
              <span
                className="hidden sm:inline font-sans uppercase text-navy/60"
                style={{ fontSize: "11px", letterSpacing: "0.18em" }}
              >
                {user}
              </span>
              <button
                type="button"
                onClick={signOut}
                data-testid="admin-signout"
                className="group inline-flex items-center gap-2 font-sans uppercase text-navy/85 hover:text-navy transition-colors"
                style={{ fontSize: "11px", letterSpacing: "0.22em" }}
              >
                <span className="relative">
                  Sign out
                  <span
                    aria-hidden="true"
                    className="absolute left-0 right-0 -bottom-1 h-px bg-gold scale-x-0 origin-left transition-transform duration-300 ease-out group-hover:scale-x-100"
                  />
                </span>
              </button>
            </div>
          ) : null}
        </div>
      </header>
      <main className="flex-1 mx-auto w-full max-w-[1100px] px-6 sm:px-8 lg:px-10 py-16 lg:py-24">
        {children}
      </main>
      <footer className="border-t border-navy/8">
        <div className="mx-auto max-w-[1100px] px-6 sm:px-8 lg:px-10 py-6 flex items-center gap-4">
          <span aria-hidden="true" className="block h-px w-8 bg-gold" />
          <p
            className="font-sans uppercase text-navy/55"
            style={{ fontSize: "10.5px", letterSpacing: "0.22em" }}
          >
            Office Console · Quantum US Capital Partners LLC
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AdminShell;
